import { actionTypes } from './gdpr.actions'

const initialState = {
    show: false,
    url: '',
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SHOW_GDPR_POPUP:
            return {
                ...state,
                show: true,
                url: action.url,
            }
        case actionTypes.CLOSE_GDPR_POPUP:
            return {
                ...state,
                show: false,
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// /src/js/common/gdpr/gdpr.reducer.js